/**
 * Product Service
 * Handles product-related API calls
 */

import apiService from '../../../services/apiService';

const productService = {
  // Get products with filters
  async getProducts(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`/shop/products?${queryParams}`);
      return response;
    } catch (error) {
      console.error('Error fetching products:', error);
      // Return mock data for now
      return {
        items: [],
        pagination: { page: 1, totalPages: 1, totalItems: 0 }
      };
    }
  },

  // Get single product
  async getProduct(id) {
    try {
      const response = await apiService.get(`/shop/products/${id}`);
      return response;
    } catch (error) {
      console.error('Error fetching product:', error);
      return null;
    }
  },

  // Get categories
  async getCategories() {
    try {
      const response = await apiService.get('/shop/categories');
      return response;
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  },

  // Search products
  async searchProducts(query) {
    try {
      const response = await apiService.get(`/shop/search?q=${encodeURIComponent(query)}`);
      return response;
    } catch (error) {
      console.error('Error searching products:', error);
      return { items: [] };
    }
  },

  // Get product reviews
  async getReviews(productId) {
    try {
      const response = await apiService.get(`/shop/products/${productId}/reviews`);
      return response;
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return [];
    }
  }
};

export default productService;

